import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosNotificationContainer } from './notification'
import { IcosNotificationService } from './notification.service'

@NgModule({
  declarations: [IcosNotificationContainer],
  exports: [IcosNotificationContainer],
  imports: [CommonModule],
  entryComponents: [IcosNotificationContainer],
})
export class IcosNotificationModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosNotificationModule, providers: [
        IcosNotificationService,
    ]}
  }
}
